import { useEffect, useState } from "react";
import { useParams } from "react-router";
import Grid from "@mui/material/Grid";
import axios from "axios";
import { find } from "lodash";
import {
  ImageList,
  ImageListItem,
  ImageListItemBar,
  useMediaQuery,
} from "@mui/material";
import { marked } from "marked";
import { Link } from "react-router-dom";

import { API_BASE_URL } from "../../services/api";
import SideNav from "../../components/SideNav";
import { makeUrl } from "../../services/api";

import "../../styles/index.scss";
import "./styles.scss";

function MainTemplate({ children }) {
  const params = useParams();
  const [error, setError] = useState(null);
  const [selectedPage, setSelectedPage] = useState(null);
  const [projects, setProject] = useState([]);
  const [pages, setPages] = useState([]);

  const isSmallScreen = useMediaQuery("(max-width:520px)");

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/pages`)
      .then(({ data }) => setPages(data))
      .catch((error) => setError(error));
  }, []);

  useEffect(() => {
    const { nav } = params;
    if (nav) {
      const pageData = find(pages, { link: `/${nav}` });
      setSelectedPage(pageData);
    }
  }, [params, selectedPage, pages]);

  useEffect(() => {
    axios
      .get(makeUrl("/projects"))
      .then(({ data }) => {
        const sortedData = data
          .filter((project) => !!project.published_at)
          .map((project) => {
            project.timestamp = new Date(project.projectDate).getTime();
            return project;
          })
          .sort((a, b) => b.timestamp - a.timestamp);
        setProject(sortedData);
      })
      .catch((error) => setError(error));
  }, []);

  function makeMenu(item) {
    item.link = `/${encodeURIComponent(item?.title?.toLowerCase())}`;
    return item;
  }

  function makeProjectMenu(item) {
    item.link = `/projects/${encodeURIComponent(item.title)}`;
    return item;
  }

  let sortedProjects = projects

  // let sortedProjects = projects.sort((a, b) => {
  //   return new Date(b.createdAt) - new Date(a.createdAt);
  // });

  console.log(sortedProjects)

  return (
    <Grid container className={`${selectedPage?.title}-page-wrapper`}>
      <Grid item xs={12} md={2}>
        <SideNav menu={pages.map(makeMenu)} />
      </Grid>
      <Grid item xs={12} md={10}>
        {selectedPage ? (
          <div
            className="page-content"
            dangerouslySetInnerHTML={{ __html: marked(selectedPage.content) }}
          />
        ) : (
          <ImageList variant="masonry" cols={isSmallScreen ? 1 : 2} gap={0} className="homepage-tiles">
            {sortedProjects.map(makeProjectMenu).map((project) => {
              return (
                <Link to={project.link} className="project-link">
                  <ImageListItem style={{ height: "340px" }}>
                    {project?.stills[0] ? (
                      // <img src={project?.stills[0].url} style={{height: 'auto'}} />
                      <div
                        style={{
                          background: `url(${project?.stills[0].url})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    ) : null}
                    <ImageListItemBar
                      title={project?.title}
                      style={{ background: "black", fontWeight: 200 }}
                    />
                  </ImageListItem>
                </Link>
              );
            })}
          </ImageList>
        )}
      </Grid>
    </Grid>
  );
}

export default MainTemplate;
